import React, { useEffect, useState } from 'react';
import { ContentCard } from '../Common';
import { Tabs } from 'antd';
import WhiteLabelSettings from './white-label';
import NotificationForm from './notifications';
import VirtualAccountsSettings from './virtual-accounts';
import TallyInvoiceForm from './tally_invoice';
import MerchantBankAccount from './merchant_bank_accounts';
import GeneralSettings from './general_settings';
import InstaCollectSettings from './InstaCollect';
import { connect } from 'react-redux';
import { PermissionHoc } from '../HOC';
import { isEmpty } from "lodash";


const Settings = (props) => {
    const [activeTab, setActiveTab] = useState(props.match.params.activeTab === "funding-accounts" ? '5' : '1');
    useEffect(() => {
        props.onChildMount();
    }, []);

    useEffect(() => {
        setActiveTab(props.match.params.activeTab === "funding-accounts" ? '5' : activeTab)
    }, [props]);

    return (
        <ContentCard className="p-3">
            <Tabs defaultActiveKey={activeTab} activeKey={activeTab} onChange={(key) => setActiveTab(key.toString())}>
                <Tabs.TabPane tab="General Settings" key="1"><GeneralSettings /></Tabs.TabPane>
                <Tabs.TabPane tab="Payout Settings" key="2"><NotificationForm /></Tabs.TabPane>
                {/* {props.current_user.is_reseller || props.current_user.eum ? <Tabs.TabPane tab="White Label" key="3"><WhiteLabelSettings /></Tabs.TabPane> : null} */}
                <Tabs.TabPane tab="Payout Accounts" key="3"><VirtualAccountsSettings /></Tabs.TabPane>
                {props.current_user.etiv ? <Tabs.TabPane tab="Tally Invoice" key="4"><TallyInvoiceForm /></Tabs.TabPane> : null}
                {props.current_user.remitter_bank_account_verification ? <Tabs.TabPane tab="Funding Accounts" key="5"><MerchantBankAccount /></Tabs.TabPane> : null}
                {props.current_user.esc && !isEmpty(props.current_user?.smart_collect_virtual_account || []) && <Tabs.TabPane tab="InstaCollect Settings" key="6"><InstaCollectSettings /></Tabs.TabPane>}
            </Tabs>
        </ContentCard>
    )
}

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

export default connect(mapStateToProps, null)(PermissionHoc(Settings, 'SETTINGS_READ'));